import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  selector: 'app-posting-form',
  standalone: true
})
export class PostingFormDirective implements OnDestroy {

  protected readonly destroyed$ = new Subject();

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
